export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CG-82ab35233fd95ac5a08173f0b304e46f.png";